import React from 'react';
import { AsyncPaginate } from 'react-select-async-paginate';
import { api } from '../../shared/api';
import '../../shared/ReactSelectDarkMode.css';

const toResults = (response) => response?.results || response?.items || response || [];

const toApiEndpoint = (nextUrl) => {
  if (!nextUrl) return null;

  const url = new URL(nextUrl, window.location.origin);
  return `${url.pathname.replace(/^\/api\//, '')}${url.search}`;
};

/**
 * Shared server-side select. It loads at most `pageSize` matching records for
 * each input value, so catalogue-like reference data is never loaded in full.
 */
export default function PaginatedAsyncSelect({
  endpoint,
  mapOption = (entry) => ({ value: entry.id, label: entry.name }),
  filterOption = () => true,
  pageSize = 20,
  queryParams = {},
  ...props
}) {
  const loadOptions = async (inputValue, loadedOptions, additional) => {
    try {
      const requestUrl = additional?.next ? toApiEndpoint(additional.next) : (() => {
        const params = new URLSearchParams({ page_size: String(pageSize), ...queryParams });
        if (inputValue?.trim()) params.set('search', inputValue.trim());
        const separator = endpoint.includes('?') ? '&' : '?';
        return `${endpoint}${separator}${params.toString()}`;
      })();
      const response = await api.get(requestUrl, { raw: true });
      return {
        options: toResults(response).filter(filterOption).map(mapOption),
        hasMore: Boolean(response?.next),
        additional: { next: response?.next || null },
      };
    } catch {
      return { options: [], hasMore: false };
    }
  };

  return (
    <AsyncPaginate
      classNamePrefix="react-select"
      className="react-select-container"
      loadOptions={loadOptions}
      defaultOptions
      cacheOptions
      isClearable
      additional={{ next: null }}
      {...props}
    />
  );
}
